function AccountSetupStep({
  selectedAccount, accounts, isUserRole,
  handleInstagramConnect, handleDisconnectAccount,
  setSelectedAccount, setCurrentStep,
}) {
  return (
    <section style={{ marginBottom: '32px' }}>
      <h3 className="text-lg sm:text-2xl font-bold mb-4 sm:mb-6 flex items-center gap-3">
        <span style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          width: '32px', height: '32px', borderRadius: '50%',
          background: '#1313ec', color: 'white', fontSize: '14px'
        }}>1</span>
        인스타그램 계정 및 API 설정
      </h3>

      {/* Instagram OAuth 연결 버튼 */}
      <div
        onClick={handleInstagramConnect}
        className="mb-4 sm:mb-6 p-4 sm:p-6 flex items-center gap-3 sm:gap-5 cursor-pointer transition-transform hover:scale-[1.01]"
        style={{
          background: 'linear-gradient(135deg, #833ab4, #fd1d1d, #fcb045)',
          borderRadius: '16px',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-2px)';
          e.currentTarget.style.boxShadow = '0 8px 24px rgba(131, 58, 180, 0.4)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = 'none';
        }}
      >
        <div style={{
          width: '48px', height: '48px', borderRadius: '12px',
          background: 'rgba(255,255,255,0.2)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: '24px', flexShrink: 0
        }}>
          &#128247;
        </div>
        <div>
          <div style={{ fontSize: '18px', fontWeight: '700', color: 'white' }}>
            인스타그램으로 연결
          </div>
          <div style={{ fontSize: '14px', color: 'rgba(255,255,255,0.8)', marginTop: '4px' }}>
            클릭 한 번으로 인스타그램 계정을 연결하세요. 토큰이 자동으로 설정됩니다.
          </div>
        </div>
        <div style={{ marginLeft: 'auto', fontSize: '24px', color: 'white', flexShrink: 0 }}>
          &#8594;
        </div>
      </div>

      {/* 연결된 계정 표시 */}
      {selectedAccount?.tokenType === 'RENEWABLE' && selectedAccount?.hasAccessToken && (
        <div style={{
          marginBottom: '24px', padding: '16px 24px',
          background: '#0d3320', borderRadius: '12px', border: '1px solid #166534',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between'
        }}>
          <div>
            <span style={{ color: '#4ade80', fontWeight: '600' }}>&#10004; OAuth 연결됨</span>
            <span style={{ color: '#9d9db9', marginLeft: '12px' }}>
              @{selectedAccount.username}
            </span>
          </div>
          <button
            onClick={() => handleDisconnectAccount(selectedAccount.id)}
            style={{
              padding: '8px 16px', background: 'transparent',
              border: '1px solid #ef4444', borderRadius: '8px',
              color: '#ef4444', fontSize: '13px', cursor: 'pointer'
            }}
          >
            연결 해제
          </button>
        </div>
      )}

      {/* 연결 완료 시 가이드 */}
      {selectedAccount?.tokenType === 'RENEWABLE' && selectedAccount?.hasAccessToken && (
        <div style={{
          marginBottom: '24px', padding: '20px 24px',
          background: '#111827', borderRadius: '12px', border: '1px solid #1e3a5f',
        }}>
          <div style={{ fontSize: '15px', fontWeight: '600', color: '#60a5fa', marginBottom: '12px' }}>
            &#128161; 연결 가이드
          </div>
          <ul style={{ margin: 0, paddingLeft: '20px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <li style={{ fontSize: '13px', color: '#9ca3af' }}>
              인스타그램 계정이 성공적으로 연결되었습니다. 자동으로 다음 단계로 이동합니다.
            </li>
            <li style={{ fontSize: '13px', color: '#9ca3af' }}>
              토큰은 <strong style={{ color: '#d1d5db' }}>60일간 유효</strong>하며, 만료 시 위 버튼을 눌러 재연결하면 됩니다.
            </li>
            <li style={{ fontSize: '13px', color: '#9ca3af' }}>
              계정을 변경하려면 <strong style={{ color: '#d1d5db' }}>연결 해제</strong> 후 다른 계정으로 다시 연결하세요.
            </li>
          </ul>
        </div>
      )}

      {/* ADMIN 전용: 기존 계정 선택 */}
      {!isUserRole && accounts.length > 0 && (
        <div style={{
          marginTop: '16px', background: '#111118', padding: '24px',
          borderRadius: '12px', border: '1px solid #3b3b54'
        }}>
          <label style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <span style={{ fontSize: '14px', fontWeight: '600', paddingLeft: '4px' }}>
              기존 계정 선택
            </span>
            <select
              value={selectedAccount?.id || ''}
              onChange={(e) => {
                const account = accounts.find(acc => acc.id === parseInt(e.target.value));
                setSelectedAccount(account);
                if (account) setCurrentStep(2);
              }}
              style={{
                width: '100%', paddingLeft: '16px', paddingRight: '16px', height: '56px',
                background: '#1c1c27', border: '1px solid #3b3b54', borderRadius: '12px',
                outline: 'none', fontSize: '16px'
              }}
            >
              <option value="">계정 선택</option>
              {accounts.map(account => (
                <option key={account.id} value={account.id}>
                  {account.username} ({account.status})
                </option>
              ))}
            </select>
          </label>
        </div>
      )}

      {/* 연결 전 안내 */}
      {!(selectedAccount?.tokenType === 'RENEWABLE' && selectedAccount?.hasAccessToken) && (
        <div style={{
          marginTop: '16px', padding: '20px 24px',
          background: '#111827', borderRadius: '12px', border: '1px solid #1e3a5f',
        }}>
          <div style={{ fontSize: '15px', fontWeight: '600', color: '#60a5fa', marginBottom: '12px' }}>
            &#128161; 시작하기 전에
          </div>
          <ul style={{ margin: 0, paddingLeft: '20px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <li style={{ fontSize: '13px', color: '#9ca3af' }}>
              위 <strong style={{ color: '#d1d5db' }}>"인스타그램으로 연결"</strong> 버튼을 클릭하면 Instagram 로그인 화면이 열립니다.
            </li>
            <li style={{ fontSize: '13px', color: '#9ca3af' }}>
              로그인 후 권한을 허용하면 <strong style={{ color: '#d1d5db' }}>자동으로 계정이 연결</strong>되고 다음 단계로 이동합니다.
            </li>
            <li style={{ fontSize: '13px', color: '#9ca3af' }}>
              Instagram <strong style={{ color: '#d1d5db' }}>비즈니스 계정</strong>이 필요합니다. 개인 계정은 설정에서 전환할 수 있습니다.
            </li>
          </ul>
        </div>
      )}
    </section>
  );
}

export default AccountSetupStep;
